import PropTypes from 'prop-types';
import React from 'react';
import './PrintLayout.scss';
import loadable from '@loadable/component';

const DeprecatedStyles = loadable(() => import('app/components/layouts/MainLayout/DeprecatedStyles'));

class Print extends React.PureComponent {
  render() {
    return (
      <DeprecatedStyles>
        <div className="cp-print">{this.props.children}</div>
      </DeprecatedStyles>
    );
  }
}

Print.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default Print;
